export const snackbarStart = (state, { message, color }) => {
  state.color = color;
  state.message = message;
  state.active = true;
};

export const snackbarStop = (state) => {
  state.active = false;
};
